const $20b5fcc183654753$export$dc537a3a3893548e = {
    init (size, root, rules) {
        this.size = size;
        this.cells = Array(size).fill().map(()=>Array(size).fill(0));
        this.table = document.createElement("table");
        this.table.classList.add("board");
        this.rules = rules;
        for(let row = 0; row < this.size; row++){
            const tr = document.createElement("tr");
            for(let col = 0; col < this.size; col++){
                const td = document.createElement("td");
                td.setAttribute("data-col", col);
                td.setAttribute("data-row", row);
                tr.appendChild(td);
            }
            this.table.appendChild(tr);
        }
        root.appendChild(this.table);
    },
    setCellValue (row, col, value) {
        const cell = this.table.rows[row].cells[col];
        value ? cell.classList.add("alive") : cell.classList.remove("alive");
        this.cells[row][col] = value;
    },
    getCellValue (row, col) {
        return this.cells[row][col];
    },
    randomize (randomizer) {
        for(let row = 0; row < this.size; row++)for(let col = 0; col < this.size; col++)this.setCellValue(row, col, randomizer());
    },
    play () {
        const nextGeneration = this.rules(this.cells);
        for(let row = 0; row < this.size; row++)for(let col = 0; col < this.size; col++)this.setCellValue(row, col, nextGeneration[row][col]);
    }
};
var $20b5fcc183654753$export$2e2bcd8739ae039 = $20b5fcc183654753$export$dc537a3a3893548e;


const $79dbfbf236bcd74c$export$2fdcdcc209570cf1 = (matrix, row, col)=>{
    const size = matrix.length;
    const directions = [
        [
            -1,
            -1
        ],
        [
            -1,
            0
        ],
        [
            -1,
            1
        ],
        [
            0,
            -1
        ],
        [
            0,
            1
        ],
        [
            1,
            -1
        ],
        [
            1,
            0
        ],
        [
            1,
            1
        ]
    ];
    const output = [];
    for (const [deltax, deltay] of directions)output.push([
        (row + deltax + size) % size,
        (col + deltay + size) % size
    ]);
    return output;
};
const $79dbfbf236bcd74c$export$87d85d3694a01d82 = (matrix, row, col)=>{
    const neighbours = $79dbfbf236bcd74c$export$2fdcdcc209570cf1(matrix, row, col);
    return neighbours.reduce((acc, curr)=>{
        if (matrix[curr[0]][curr[1]]) acc++;
        return acc;
    }, 0);
};
const $79dbfbf236bcd74c$export$d812b19e9bed0f21 = (matrix)=>{
    let counts, isAlive;
    const output = Array(matrix.length).fill().map(()=>Array(matrix.length).fill(0));
    for(let row = 0; row < matrix.length; row++)for(let col = 0; col < matrix.length; col++){
        counts = $79dbfbf236bcd74c$export$87d85d3694a01d82(matrix, row, col);
        isAlive = matrix[row][col] === 1;
        if (isAlive && (counts === 2 || counts === 3)) output[row][col] = 1;
        else if (!isAlive && counts === 3) output[row][col] = 1;
        else output[row][col] = 0;
    }
    return output;
};


const $1f0dc3b9307be026$var$root = document.querySelector("main");
(0, $20b5fcc183654753$export$dc537a3a3893548e).init(120, $1f0dc3b9307be026$var$root, (0, $79dbfbf236bcd74c$export$d812b19e9bed0f21));
(0, $20b5fcc183654753$export$dc537a3a3893548e).randomize(()=>Math.round(Math.random()) === 1);
setInterval(()=>{
    (0, $20b5fcc183654753$export$dc537a3a3893548e).play();
}, 100);


//# sourceMappingURL=index.cfe24531.js.map
